// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4694":"css/app.6763","6907":"css/admin-app.6763"}[chunkId] + ".css";
};